module.exports = __webpack_public_path__ + "img/6.b27986d8.png";